/**
 * @file     FlowPresentation.tsx
 * @readme   ../README.md
 * @purpose  Context the FlowRenderer hands to its steps: whether the step sits inside the shared step card (and so draws no card of its own), the heading level its question uses, and the density of the surface it lives in.
 */
'use client';

import { createContext, useContext } from 'react';

export type FlowHeadingLevel = 'h2' | 'h3';
export type FlowDensity = 'regular' | 'compact';

export type FlowPresentationValue = {
  /** The FlowRenderer already drew the card; the step renders flat inside it. */
  inShell: boolean;
  /** Level for each step's question. Never h1: the page owns its H1. */
  headingLevel: FlowHeadingLevel;
  density: FlowDensity;
};

const DEFAULT_PRESENTATION: FlowPresentationValue = {
  inShell: false,
  headingLevel: 'h2',
  density: 'regular',
};

export const FlowPresentationContext = createContext<FlowPresentationValue>(DEFAULT_PRESENTATION);

export const useFlowPresentation = (): FlowPresentationValue => useContext(FlowPresentationContext);
